export default __webpack_public_path__ + "static/media/mobile.dd4e0cdc.png";